"use client";

import { BookMenuContext } from "@/context/bookMenuContext";
import { LanguageContext } from "@/context/languageContext";
import styles from "@/styles/modules/components/buyout/moduleContent.module.scss";
import { Link as LinkType } from "@/types/wordpress-parts";
import { translate } from "@/utils/translate";
import Link from "next/link";
import { useContext } from "react";

interface ModuleContentProps {
  title: string;
  body: string;
  links: { link: LinkType }[];
}

export default function ModuleContent({
  title,
  body,
  links,
}: ModuleContentProps) {
  const { language } = useContext(LanguageContext);
  const { setCurrentBookMenu, openBookMenu } = useContext(BookMenuContext);

  const handleEnquire = () => {
    setCurrentBookMenu(2);
    openBookMenu();
  };

  return (
    <section className={styles.moduleContent}>
      <div className={styles.moduleContentContainer}>
        <div className={styles.text}>
          <h1 data-aos="fadeIn">{title}</h1>
          <p
            dangerouslySetInnerHTML={{
              __html: body,
            }}
            data-aos="fadeIn"
            data-aos-delay="200"
          />
        </div>
        <div className={styles.links} data-aos="fadeIn" data-aos-delay="400">
          {links &&
            links.length > 0 &&
            links.map((item, i) => (
              <Link key={i} href={item.link.url} target={item.link.target}>
                {item.link.title}
              </Link>
            ))}
          <button onClick={handleEnquire}>
            {translate["enquireNow"][language]}
          </button>
        </div>
      </div>
    </section>
  );
}
